// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-dealers-list {
  /* Colors */
  --perxis-auto-dealers-list-background-color-inner: var(
      --perxis-auto-dealers-list-background-color,
      var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Scrollbar */
  --perxis-auto-dealers-list-scrollbar-width-inner: var(--perxis-auto-dealers-list-scrollbar-width, 8px);
  --perxis-auto-dealers-list-scrollbar-track-background-color-inner: var(
      --perxis-auto-dealers-list-scrollbar-track-background-color,
      var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-dealers-list-scrollbar-thumb-background-color-inner: var(
      --perxis-auto-dealers-list-scrollbar-thumb-background-color,
      var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-dealers-list-scrollbar-thumb-border-radius-inner: var(
      --perxis-auto-dealers-list-scrollbar-thumb-border-radius,
      5px
  );
  /* End Scrollbar */
  height: 100%;
  background-color: var(--perxis-auto-dealers-list-background-color-inner);
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-color: var(--perxis-auto-dealers-list-scrollbar-thumb-background-color-inner);
}
.perxis-auto-1_16_0-dealers-list::-webkit-scrollbar {
  width: var(--perxis-auto-dealers-list-scrollbar-width-inner);
}
.perxis-auto-1_16_0-dealers-list::-webkit-scrollbar-track {
  background: var(--perxis-auto-dealers-list-scrollbar-track-background-color-inner);
}
.perxis-auto-1_16_0-dealers-list::-webkit-scrollbar-thumb {
  background-color: var(--perxis-auto-dealers-list-scrollbar-thumb-background-color-inner);
  border-radius: var(--perxis-auto-dealers-list-scrollbar-thumb-border-radius-inner);
}

.perxis-auto-1_16_0-dealers-list-item {
  /* Typography */
  --perxis-auto-dealers-list-item-title-font-family-inner: var(
      --perxis-auto-dealers-list-item-title-font-family,
      var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-dealers-list-item-title-font-size-inner: var(--perxis-auto-dealers-list-item-title-font-size, 16px);
  --perxis-auto-dealers-list-item-title-font-weight-inner: var(--perxis-auto-dealers-list-item-title-font-weight, 700);
  --perxis-auto-dealers-list-item-title-letter-spacing-inner: var(
      --perxis-auto-dealers-list-item-title-letter-spacing,
      var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-dealers-list-item-title-line-height-inner: var(--perxis-auto-dealers-list-item-title-line-height, 1.2);
  --perxis-auto-dealers-list-item-title-text-transform-inner: var(
      --perxis-auto-dealers-list-item-title-text-transform,
      var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-dealers-list-item-title-color-inner: var(
      --perxis-auto-dealers-list-item-title-color,
      var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-dealers-list-item-background-color-inner: var(
      --perxis-auto-dealers-list-item-background-color,
      var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-dealers-list-item-hover-background-color-inner: var(
      --perxis-auto-dealers-list-item-hover-background-color,
      var(--perxis-auto-root-thirteenth-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-dealers-list-item-border-top-inner: var(
      --perxis-auto-dealers-list-item-border-top,
      1px solid var(--perxis-auto-root-ninth-color-inner)
  );
  --perxis-auto-dealers-list-item-border-bottom-inner: var(
      --perxis-auto-dealers-list-item-border-bottom,
      var(--perxis-auto-dealers-list-item-border-top-inner)
  );
  /* End Border */
  /* Padding */
  --perxis-auto-dealers-list-item-padding-inner: var(
      --perxis-auto-dealers-list-item-padding,
      var(--perxis-auto-gap-vertical-green-inner) 18px
  );
  /* End Border */
  position: relative;
  padding: var(--perxis-auto-dealers-list-item-padding-inner);
  border-top: var(--perxis-auto-dealers-list-item-border-top-inner);
  background-color: var(--perxis-auto-dealers-list-item-background-color-inner);
  cursor: pointer;
}
.perxis-auto-1_16_0-dealers-list-item:last-child {
  border-bottom: var(--perxis-auto-dealers-list-item-border-bottom-inner);
}
.perxis-auto-1_16_0-dealers-list-item .perxis-auto-1_16_0-dealers-list-item__title-wrapper {
  margin-bottom: 8px;
}
@media (max-width: 991px) {
  .perxis-auto-1_16_0-dealers-list-item:first-child {
    border-top-color: transparent;
  }
}
.perxis-auto-1_16_0-dealers-list-item:hover, .perxis-auto-1_16_0-dealers-list-item--hovered {
  background: var(--perxis-auto-dealers-list-item-hover-background-color-inner);
  transition: 0.2s;
  border-top-color: transparent;
}
.perxis-auto-1_16_0-dealers-list-item:hover + .perxis-auto-1_16_0-dealers-list-item, .perxis-auto-1_16_0-dealers-list-item--hovered + .perxis-auto-1_16_0-dealers-list-item {
  border-top-color: transparent;
}
.perxis-auto-1_16_0-dealers-list-item:hover .perxis-auto-1_16_0-dealers-list-item__forward, .perxis-auto-1_16_0-dealers-list-item--hovered .perxis-auto-1_16_0-dealers-list-item__forward {
  opacity: 1;
}
.perxis-auto-1_16_0-dealers-list-item:hover .perxis-auto-1_16_0-dealers-list-item__tags--overflow::after, .perxis-auto-1_16_0-dealers-list-item--hovered .perxis-auto-1_16_0-dealers-list-item__tags--overflow::after {
  content: "";
  background: linear-gradient(270deg, var(--perxis-auto-dealers-list-item-hover-background-color-inner) 25%, rgba(255, 255, 255, 0) 100%);
}
.perxis-auto-1_16_0-dealers-list-item__brand-image {
  max-height: 40px;
  width: auto;
}
.perxis-auto-1_16_0-dealers-list-item__address {
  /* Typography */
  --perxis-auto-dealer-list-item-address-font-family-inner: var(
      --perxis-auto-dealer-list-item-address-font-family,
      var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-list-item-address-font-weight-inner: var(
      --perxis-auto-dealer-list-item-address-font-weight,
      var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealers-list-item-address-line-height-inner: var(
      --perxis-auto-dealers-list-item-address-line-height,
      1.5
  );
  /* End Typography */
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-list-item-address-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-list-item-address-font-weight-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealers-list-item-address-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealers-list-item-address-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealers-list-item-address-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealers-list-item-address-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealers-list-item-address-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealers-list-item-address-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealers-list-item-address-line-height-inner);
}
.perxis-auto-1_16_0-dealers-list-item__phone {
  /* Typography */
  --perxis-auto-dealer-list-item-phone-font-family-inner: var(
      --perxis-auto-dealer-list-item-phone-font-family,
      var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-list-item-phone-font-weight-inner: var(
      --perxis-auto-dealer-list-item-phone-font-weight,
      var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealers-list-item-phone-line-height-inner: var(
      --perxis-auto-dealers-list-item-phone-line-height,
      1.5
  );
  /* End Typography */
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-list-item-phone-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-list-item-phone-font-weight-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealers-list-item-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealers-list-item-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealers-list-item-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealers-list-item-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealers-list-item-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealers-list-item-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealers-list-item-phone-line-height-inner);
}
.perxis-auto-1_16_0-dealers-list-item__tags {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}
.perxis-auto-1_16_0-dealers-list-item__tags--overflow::after {
  content: "";
  position: absolute;
  right: 0;
  width: 20px;
  height: 100%;
  background: linear-gradient(270deg, var(--perxis-auto-dealers-list-item-background-color-inner) 25%, rgba(255, 255, 255, 0) 100%);
}
.perxis-auto-1_16_0-dealers-list-item__title {
  --perxis-auto-typography-main-font-family: var(--perxis-auto-dealers-list-item-title-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-dealers-list-item-title-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-dealers-list-item-title-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-dealers-list-item-title-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealers-list-item-title-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-dealers-list-item-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-dealers-list-item-title-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-dealers-list-item-title-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-dealers-list-item-title-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-dealers-list-item-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-dealers-list-item-title-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-dealers-list-item-title-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-dealers-list-item-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-dealers-list-item-title-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-dealers-list-item-title-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-dealers-list-item-title-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-dealers-list-item-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-dealers-list-item-title-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-dealers-list-item-title-line-height-inner);
}
.perxis-auto-1_16_0-dealers-list-item__forward.perxis-auto-1_16_0-icon {
  /* Typography */
  /* Typography icon */
  --perxis-auto-dealers-list-item-forward-icon-size-inner: var(
      --perxis-auto-dealers-list-item-forward-icon-size,
      24px
  );
  --perxis-auto-dealers-list-item-forward-icon-color-inner: var(
      --perxis-auto-dealers-list-item-forward-icon-color,
      var(--perxis-auto-root-fourth-color-inner)
  );
  /* Typography End */
  --perxis-auto-icon-font-size: var(--perxis-auto-dealers-list-item-forward-icon-size-inner);
  color: var(--perxis-auto-dealers-list-item-forward-icon-color-inner);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.perxis-auto-1_16_0-dealers-list-item__forward-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
